export const requestNotificationPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        console.log("Permisos de notificación concedidos.");
      } else {
        console.warn("Permisos de notificación denegados.");
      }
    } catch (error) {
      console.error("Error al solicitar permisos de notificación:", error);
    }
  };
  